export default {
 UploadBaseAddress: '',
UploadBaseUrl: 'https://rebel-env.s3.us-west-2.amazonaws.com/rspi/stage/rspi-api/uploads'
};